// extracted by mini-css-extract-plugin
module.exports = {"container":"ScaleBox_container__14tci","point":"ScaleBox_point__2Avw-","pointFocus":"ScaleBox_pointFocus__2Q4eF"};